import { render, staticRenderFns } from "./identificationForm.vue?vue&type=template&id=48fcc108&scoped=true&"
import script from "./identificationForm.vue?vue&type=script&lang=js&"
export * from "./identificationForm.vue?vue&type=script&lang=js&"
import style0 from "./identificationForm.vue?vue&type=style&index=0&id=48fcc108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fcc108",
  null
  
)

export default component.exports